(function() {
  const $c0fbfe5e6739a59a$var$prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $c0fbfe5e6739a59a$var$supportsIntersectionObserver = "IntersectionObserver" in window;
  const $c0fbfe5e6739a59a$var$isDesignMode = window.Shopify && window.Shopify.designMode;
  const $c0fbfe5e6739a59a$var$initialized = new WeakSet;
  let $c0fbfe5e6739a59a$var$sharedObserver = null;
  function $c0fbfe5e6739a59a$var$reveal(container) {
    container.setAttribute("data-revealed", "");
  }
  if ($c0fbfe5e6739a59a$var$supportsIntersectionObserver && !$c0fbfe5e6739a59a$var$prefersReducedMotion && !$c0fbfe5e6739a59a$var$isDesignMode) $c0fbfe5e6739a59a$var$sharedObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      $c0fbfe5e6739a59a$var$reveal(entry.target);
      $c0fbfe5e6739a59a$var$sharedObserver.unobserve(entry.target);
    }
  }, {
    rootMargin: "0px 0px -5% 0px",
    threshold: .05
  });
  function $c0fbfe5e6739a59a$var$initScrollReveal() {
    const containers = document.querySelectorAll("[data-reveal]");
    for (const container of containers) {
      if ($c0fbfe5e6739a59a$var$initialized.has(container)) continue;
      const items = container.querySelectorAll("[data-reveal-item]");
      if (items.length === 0) {
        $c0fbfe5e6739a59a$var$initialized.add(container);
        continue;
      }
      items.forEach((element, index) => {
        element.style.setProperty("--reveal-index", String(Math.min(index, 9)));
      });
      $c0fbfe5e6739a59a$var$initialized.add(container);
      if (!$c0fbfe5e6739a59a$var$sharedObserver) {
        $c0fbfe5e6739a59a$var$reveal(container);
        continue;
      }
      $c0fbfe5e6739a59a$var$sharedObserver.observe(container);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $c0fbfe5e6739a59a$var$initScrollReveal, {
    once: true
  }); else $c0fbfe5e6739a59a$var$initScrollReveal();
  document.addEventListener("shopify:section:load", $c0fbfe5e6739a59a$var$initScrollReveal);
})();